import { useField } from 'formik';
import RadioButton from 'components/RadioButton';

const Option = ({ value, personType = '', avatar, title, subtitle = '' }) => {
  const [field] = useField({ name: 'person_id', type: 'radio', value });
  const [typeField, , typeHelpers] = useField('person_type');

  const checked = field.checked && typeField.value === personType;

  const handleChange = (event) => {
    field.onChange(event);
    typeHelpers.setValue(personType);
  };

  return (
    <RadioButton
      {...field}
      checked={checked}
      onChange={handleChange}
      className={`border-b border-gray-100 px-4 py-3 transition-colors last:border-b-0 sm:gap-4 sm:px-5 ${checked ? 'bg-blue-50/60' : 'hover:bg-secondary-50'}`}
    >
      {avatar}

      <div className="min-w-0 flex-1">
        <p className="truncate text-[15px] font-bold text-secondary-900">{title}</p>
        {subtitle && <p className="mt-0.5 truncate text-sm text-secondary-400">{subtitle}</p>}
      </div>
    </RadioButton>
  );
};

export default Option;
